export default __webpack_public_path__ + "static/media/timeline.b29a6a23.png";